module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_4.8cdb8448.jpg";